import { NavigationCardStateType } from '../../../../../../components/navigationCard/types/state';
import { NavigationCardContainerVariantType } from '../../../../../../components/navigationCardContainer/types/navigationCardContainer';
import { NavigationCardContainerOptionType } from '../../../../../../components/navigationCardContainer/types/option';
import { defaultCommonStyles, disabledCommonStyles, firstCommonStyles, lastCommonStyles, middleCommonStyles, pressedCommonStyles, uniqueCommonStyles, } from '../commonStyles';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [NavigationCardContainerVariantType.DEFAULT]: {
            [NavigationCardContainerOptionType.UNIQUE]: {
                [NavigationCardStateType.DEFAULT]: {
                    parentContainer: {
                        ...uniqueCommonStyles(FOUNDATIONS, FONT),
                        ...defaultCommonStyles(FOUNDATIONS, FONT),
                    },
                },
                [NavigationCardStateType.PRESSED]: {
                    parentContainer: {
                        ...uniqueCommonStyles(FOUNDATIONS, FONT),
                        ...pressedCommonStyles(FOUNDATIONS, FONT),
                    },
                },
                [NavigationCardStateType.DISABLED]: {
                    parentContainer: {
                        ...uniqueCommonStyles(FOUNDATIONS, FONT),
                        ...disabledCommonStyles(FOUNDATIONS, FONT),
                    },
                },
            },
            [NavigationCardContainerOptionType.FIRST]: {
                [NavigationCardStateType.DEFAULT]: {
                    parentContainer: {
                        ...firstCommonStyles(FOUNDATIONS, FONT),
                        ...defaultCommonStyles(FOUNDATIONS, FONT),
                    },
                },
                [NavigationCardStateType.PRESSED]: {
                    parentContainer: {
                        ...firstCommonStyles(FOUNDATIONS, FONT),
                        ...pressedCommonStyles(FOUNDATIONS, FONT),
                    },
                },
                [NavigationCardStateType.DISABLED]: {
                    parentContainer: {
                        ...firstCommonStyles(FOUNDATIONS, FONT),
                        ...disabledCommonStyles(FOUNDATIONS, FONT),
                    },
                },
            },
            [NavigationCardContainerOptionType.MIDDLE]: {
                [NavigationCardStateType.DEFAULT]: {
                    parentContainer: {
                        ...middleCommonStyles(FOUNDATIONS, FONT),
                        ...defaultCommonStyles(FOUNDATIONS, FONT),
                    },
                },
                [NavigationCardStateType.PRESSED]: {
                    parentContainer: {
                        ...middleCommonStyles(FOUNDATIONS, FONT),
                        ...pressedCommonStyles(FOUNDATIONS, FONT),
                    },
                },
                [NavigationCardStateType.DISABLED]: {
                    parentContainer: {
                        ...middleCommonStyles(FOUNDATIONS, FONT),
                        ...disabledCommonStyles(FOUNDATIONS, FONT),
                    },
                },
            },
            [NavigationCardContainerOptionType.LAST]: {
                [NavigationCardStateType.DEFAULT]: {
                    parentContainer: {
                        ...lastCommonStyles(FOUNDATIONS, FONT),
                        ...defaultCommonStyles(FOUNDATIONS, FONT),
                    },
                },
                [NavigationCardStateType.PRESSED]: {
                    parentContainer: {
                        ...lastCommonStyles(FOUNDATIONS, FONT),
                        ...pressedCommonStyles(FOUNDATIONS, FONT),
                    },
                },
                [NavigationCardStateType.DISABLED]: {
                    parentContainer: {
                        ...lastCommonStyles(FOUNDATIONS, FONT),
                        ...disabledCommonStyles(FOUNDATIONS, FONT),
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=default.js.map